/** Labels of the vertical player controls (screen readers, keyboard users). */
export const reelsHe = {
  dialog: 'נגן סרטונים',
  close: 'סגירת הנגן',
  mute: 'השתקה',
  unmute: 'הפעלת סאונד',
  share: 'שיתוף',
  play: 'ניגון',
  previous: 'לסרטון הקודם',
  next: 'לסרטון הבא',
  closeAd: 'סגירה',
  loading: 'טוען',
} as const
